export default "__VITE_ASSET__Bu_i3M6n__"